import React, {useState, useEffect} from "react"
import {useSelector} from "react-redux"

//slices

// UI
import {H4} from "@uprise/headings"
import {Row, Col} from "@uprise/grid"
import {extended} from "@uprise/colors"
import styled from "styled-components"
// Components
import NotesSummary from "../NotesSummary"

const HR = styled.div`
	width: 100%;
	height: 1px;
	background: ${extended.purple.three};
	margin: 10px 0;
`

const NotesContainer = ({data, coaches, isRcb, auth = false, start}) => {
	const [errorText, setErrorText] = useState("No Data Found")
	const [error, setError] = useState(false)

	useEffect(() => {
		if (!auth || !data.length) setError(true)

		if (!data.length) setErrorText("No Data Found")
		else if (!auth && !isRcb) setErrorText("Unfortunately, you do not have access to this user's session notes")
		else if (!auth && isRcb) setErrorText("Unfortunately, you do not have access to this user's RCB notes")
	}, [auth, data, isRcb])

	const getCoachName = item => {
		if (isRcb) return coaches.find(coach => coach.id === item.coachId)?.name || "N/A"
		else return coaches.find(coach => coach.id === item.coachId)?.name || "N/A"
	}

	return (
		<>
			{error ? (
				<Row>
					<Col>
						<H4 className='text-center'>{errorText}</H4>
					</Col>
				</Row>
			) : (
				<>
					<Row style={{marginTop: "10px"}}>
						<Col className='col-lg-2 col-2'>
							<H4>{isRcb ? "Wellbeing Therapist" : "Coach Name"}</H4>
						</Col>
						<Col className='col-lg-2 col-2'>
							<H4>{isRcb ? "Date" : "Session Date"}</H4>
						</Col>
						{!isRcb && (
							<Col className='col-lg-2 col-2'>
								<H4>Note last updated</H4>
							</Col>
						)}
						<Col className='col-lg-6 col-6'>
							<H4>Note</H4>
						</Col>
					</Row>
					<HR />
					{data?.map((item, idx) => (
						<NotesSummary
							key={idx}
							coachName={getCoachName(item)}
							date={item.updatedAt}
							createdAt={isRcb ? item.createdAt : item.start}
							note={isRcb ? item.content : item.note}
						/>
					))}
				</>
			)}
		</>
	)
}

export default NotesContainer
